'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('admin-page-edit', {
      url: '/admin/page/edit/:id',
      template: '<admin-page-edit></admin-page-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/page/edit/page-edit.routes.js